// import React, { Component } from "react";
import VIDABOO_CONSTANTS from '../config/consts';
import utilsService from './utilsService';
////////////////////// Service Template Head  /////////////////////////

// let privateState = {}; // private variables for this service.
let service = {};
service.data = {};

////////////////////// End Service Template Head  /////////////////////////

////////////////////// Start Service Implementation:  /////////////////////////
service.get = function (key) {
  return service.getItem(key);
};
service.set = function (key, data) {
  service.setItem(key, data);
};
service.getItem = function (key) {
  if (utilsService.isLocalStorageSupported()) {
    return localStorage.getItem(key);
  } else {
    return service.data[key];
  }
};
service.removeItem = function (key) {
  localStorage.removeItem(key);
};
service.setItem = function (key, data) {
  if (utilsService.isLocalStorageSupported()) {
    localStorage.setItem(key, data);
  } else {
    service.data[key] = data;
  }
};
service.isKeyExist = function (key) {
  if (utilsService.isLocalStorageSupported()) {
    return localStorage.getItem(key) !== null;
  }
  return false;
};
service.setObj = (key, obj) => {
  if (utilsService.isLocalStorageSupported()) {
    localStorage.setItem(key, JSON.stringify(obj));
  }
};

service.getCookie = (name) => {
  if (utilsService.isLocalStorageSupported()) {
    // service.isLocalStorageSupported;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  } else {
    return '';
  }
};
service.setCookie = (name, value, days) => {
  if (utilsService.isLocalStorageSupported()) {
    days = days ?? 1;
    const now = new Date();
    const time = now.getTime();
    const expireTime = time + 1000 * 60 * 60 * 24 * days;
    const expireDate = new Date(expireTime);
    const nameToCookie = encodeURIComponent(name);
    const valueToCookie = encodeURIComponent(value);
    const domain = VIDABOO_CONSTANTS.TEST_ENV ? 'yuvidio.com' : 'consolto.com';
    document.cookie =
      nameToCookie +
      '=' +
      valueToCookie +
      ';Expires=' +
      expireDate.toUTCString() +
      ';Path=/;Domain=' +
      domain +
      ';SameSite=None;Secure';
  }

  // const cookieStr = document.cookie;
  // let cookieNewStr = '';
  // console.debug(cookieStr);
  // if (cookieStr.length > 0) {
  //   const cookielist = cookieStr.split(';');
  //   for (var i = 0; i < cookielist.length; i++) {
  //     let cookieItem = cookielist[i];
  //     let [itemName, itemValue] = cookieItem.split(`=`);
  //     if (itemName === nameToCookie || itemName === ' ' + nameToCookie)
  //       itemValue = valueToCookie;
  //     cookieItem = itemName + '=' + itemValue + ';';
  //     cookieNewStr += cookieItem;
  //   }
  // } else {
  //   cookieNewStr = ' ' + name + '=' + value + ';';
  // }
  // document.cookie = cookieNewStr;
  // console.debug(document.cookie);
};
service.removeCookieItem = (name) => {
  if (utilsService.isLocalStorageSupported()) {
    const domain = VIDABOO_CONSTANTS.TEST_ENV ? 'yuvidio.com' : 'consolto.com';

    document.cookie =
      encodeURIComponent(name) +
      '=;Path=/;Domain=' +
      domain +
      ';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
};

const storageService = {...service};
export default storageService;
